import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
//api
import { editInvoice, getDetailInvoice } from 'api/invoice';
//components
import Title from 'components/backoffice/texts/title';
import InvoiceForm from 'components/backoffice/forms/invoiceForm';

const EditInvoice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['backoffice']);
  const [invoice, setInvoice] = useState([]);
  const {setTitle} = useOutletContext()

  const getInvoice = async () => {
    const { data, status } = await getDetailInvoice(id);
    if (status === 200) {
      setInvoice(data);
    } else {
      setInvoice([]);
    }
  };

  useEffect(() => {
    getInvoice();
  }, []);

  useEffect(()=>{
    if(invoice){
      setTitle(t('edit',{title: invoice?.name}))
    }
    return () => {
      setTitle('');
    };
  },[invoice, setTitle])

  const onSubmit = useCallback(async (values) => {
    setLoading(true)
    try {
      const payload = {
        status: values.status,
        billing_address: values.billing_address ? values.billing_address : invoice.order?.billing_address,
      };
      const { status } = await editInvoice(id, payload);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/invoices', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
      setLoading(false)
    } catch (error) {
      console.error('Error en onCreate:', error);
    }
  }, []);

  return (
    <div>
      <Title text={t('editar')} />
      <InvoiceForm 
        loading={loading} 
        isEditing={true} 
        onSubmitForm={onSubmit} 
        defaultValues={invoice} 
        id={id} 
      />
    </div>
  );
};

export default EditInvoice;
